import ExternalEvents from "./ExternalEvents";

export default class Modal extends ExternalEvents {
    constructor(el) {
        super(["open", "close"]);
        this.el = el;
        this.isOpened = false;
        this.handleEscapeCloseBinded = this.handleEscapeClose.bind(this);
    }

    getModal() {
        if (this.el.dataset && this.el.dataset.modalTarget) {
            return document.querySelector(this.el.dataset.modalTarget);
        }

        return this.el.querySelector(".modal");
    }

    getCloseElements() {
        return this.modal.querySelectorAll(".modal__close");
    }

    getOpenElements() {
        return this.el.querySelectorAll(".modal__open");
    }

    toggleModal(e) {
        e.preventDefault();

        this.isOpened = !this.isOpened;

        this.modal.classList.toggle("modal--active");
        document.body.classList.toggle("freeze");

        this.setEscapeEventListener();
        this.runExternalEventHandlers(this.isOpened ? "open" : "close", e);
    }

    handleModalClick(e) {
        if (e.target !== e.currentTarget) return;

        this.toggleModal(e);
    }

    handleEscapeClose(e) {
        if (e.key === "Escape") this.toggleModal(e);
    }

    setEscapeEventListener() {
        this.isOpened
            ? document.addEventListener("keydown", this.handleEscapeCloseBinded, false)
            : document.removeEventListener("keydown", this.handleEscapeCloseBinded, false);
    }

    setEventListeners() {
        if (!this.openElements) return;

        this.openElements.forEach((element) =>
            element.addEventListener("click", this.toggleModal.bind(this))
        );
        this.modal.addEventListener("click", this.handleModalClick.bind(this));

        if (this.closeElements)
            this.closeElements.forEach((element) =>
                element.addEventListener("click", this.toggleModal.bind(this))
            );
    }

    run() {
        this.modal = this.getModal();

        if (!this.modal) return;

        this.openElements = this.getOpenElements();
        this.closeElements = this.getCloseElements();
        this.setEventListeners();
    }
}
